import React, {Component} from 'react';
import axios from 'axios';
import FormContact from '../components/FormContact';
import {Link} from 'react-router';


class Contact extends Component
{
  constructor(props) {
      super(props);
      this.state = {
          emailValid: false,
          subjectValid: false,
          contenttValid: false,
          showForm: true,
          showAjaxResponse: false,
          showSpinner:false,
          mailResponse: '',
      };

      this.handleSubmit = this.handleSubmit.bind(this);
  }

    handleClick(e) {
        e.preventDefault();
        this.setState({showForm: false});
    }

    handleSubmit(e) {
        e.preventDefault();
        if (e.target.email.value && e.target.subject.value && e.target.content.value) {
            var data = {
                email: e.target.email.value,
                subject: e.target.subject.value,
                content: e.target.content.value
            };
            var self = this;
            this.setState({showForm: false,showSpinner:true});
            axios.post('/mail', data).then(function(response) {
                self.setState({showAjaxResponse:true,mailResponse: response.data,showSpinner:false});
            }).catch(function(error) {
;                self.setState({showAjaxResponse:true,mailResponse: error.data,showSpinner:false});
            });
        }
    }

    render() {
      const showForm = this.state.showForm;
      const showSpinner = this.state.showSpinner;
      const showAjaxResponse = this.state.showAjaxResponse;
        return (
            <div className="main" style={{overflow:"scroll"}}>
                <div className="outer">
                    <div className="middle">
                    <div className="col-lg-12">
                      {
                        showForm ? (<FormContact onSubmit={this.handleSubmit} subject={this.props.params.subject} />) : ('')
                      }
                      {
                        showSpinner ? (<img src="ajax-loader.gif" role="presentation"></img>) : ('')
                      }
                      {
                        showAjaxResponse ? (<div>{this.state.mailResponse}
                              <br/>
                              <Link href="/contact">return</Link>
                        </div>) : ('')
                      }
                    </div>
                </div>
              </div>
            </div>
        )
    }
}



export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact.js